<form>
    <div class="grid">
        <div class="col-12 input-field">
            <label for="capabilityId">Compañía *</label>
            <p-dropdown [options]="companies" [(ngModel)]="results.companyId" [ngModelOptions]="{standalone:true}"  optionValue="id" [filter]="true"
                filterBy="name" optionLabel="name" (onChange)="loadContracts()" placeholder="Seleccione compañía"
                appendTo="body" d-form-field-error [required]="true" />
        </div>
        <div class="col-12 input-field">
            <label for="capabilityId">Contrato</label>
            <p-multiSelect  [options]="contracts" [(ngModel)]="results.selectedContracts"
                placeholder="Todos los contratos" optionLabel="name" display="chip" appendTo="body" [ngModelOptions]="{standalone:true}" 
                optionValue="id"
                showClear />
        </div>
    </div>

    <div class="mt-4 flex gap-2 justify-content-end">
        <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
        <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2" (click)="save()"></p-button>
    </div>

</form>